export { HighlightedSegment } from './highlighted-segment';
export type { HighlightedSegmentProps } from './highlighted-segment';
